import { MdPsychology, MdPhoneInTalk, MdChatBubbleOutline } from 'react-icons/md';

const IA = () => (
    <div className="flex flex-col gap-5">
        {/* Header */}
        <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
            <div className="flex items-start gap-4">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-purple-soft">
                    <MdPsychology className="h-5 w-5 text-leadrs-purple-focus" />
                </div>
                <div>
                    <div className="flex items-center gap-3">
                        <h2 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text">
                            IA de requalification
                        </h2>
                        <span className="rounded-full bg-leadrs-yellow-soft px-3 py-1 font-geist text-xs font-medium text-leadrs-yellow-focus">
                            Bientôt disponible
                        </span>
                    </div>
                    <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                        Requalifiez vos leads grâce à l'intelligence artificielle et maximisez votre taux de conversion.
                    </p>
                </div>
            </div>
        </div>

        {/* Feature description */}
        <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
            <h3 className="font-crimson text-xl font-semibold text-leadrs-text">
                Validation IA de vos leads
            </h3>
            <p className="mt-2 font-geist text-sm leading-relaxed text-leadrs-text-soft">
                Leadrs va au-delà de la simple génération de leads. Dès qu'un lead est capturé, notre intelligence artificielle entre en action pour le requalifier via des canaux puissants et ciblés.
            </p>

            <div className="mt-6 flex flex-col gap-4">
                <div className="flex items-start gap-4 rounded-xl border border-leadrs-stroke p-4">
                    <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-purple-soft">
                        <MdPhoneInTalk className="h-5 w-5 text-leadrs-purple-focus" />
                    </div>
                    <div>
                        <p className="font-geist text-sm font-semibold text-leadrs-text">
                            Robots d'appel intelligents
                        </p>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Contactent automatiquement vos prospects pour valider et enrichir les informations recueillies.
                        </p>
                    </div>
                </div>

                <div className="flex items-start gap-4 rounded-xl border border-leadrs-stroke p-4">
                    <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-green-soft">
                        <MdChatBubbleOutline className="h-5 w-5 text-leadrs-green-focus" />
                    </div>
                    <div>
                        <p className="font-geist text-sm font-semibold text-leadrs-text">
                            Messagerie automatique WhatsApp
                        </p>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Dialogue instantané pour recueillir des données supplémentaires et identifier les besoins de chaque prospect.
                        </p>
                    </div>
                </div>
            </div>

            <p className="mt-5 font-geist text-sm leading-relaxed text-leadrs-text-soft">
                Ce processus assure une requalification de haute précision — des leads chauds, parfaitement alignés avec vos offres.
            </p>
        </div>
    </div>
);

export default IA;
